/** Hand-written, source-cited deep answers for high-impression question pages. Never generate these from templates. */
import tm30Img from "@/assets/qa-tm30-registration.jpg";
import civilImg from "@/assets/hero-civilreg-960.webp";
import poaImg from "@/assets/hero-poa-960.webp";

export type DeepDive = {
  image: { src: string; alt: string; width: number; height: number };
  sections: { h: string; p: string[] }[];
  steps?: string[];
  cautions: string[];
  sources: { label: string; url: string }[];
  reviewedTh: string;
};

const REVIEWED = "9 ตุลาคม 2569";

const IMMIGRATION_ACT = { label: "พระราชบัญญัติคนเข้าเมือง พ.ศ. 2522 (สำนักงานคณะกรรมการกฤษฎีกา)", url: "https://www.krisdika.go.th/" };
const TM30_PORTAL = { label: "ระบบแจ้งที่พักคนต่างด้าวออนไลน์ (ตม.30) สำนักงานตรวจคนเข้าเมือง", url: "https://tm30.immigration.go.th/" };
const IMMIGRATION = { label: "สำนักงานตรวจคนเข้าเมือง", url: "https://www.immigration.go.th/" };

export const QA_DEEP_DIVES: Record<string, DeepDive> = {
  "/work-permit/q/tm30-notification-city-chiangmai": {
    image: { src: tm30Img, alt: "เจ้าของที่พักบันทึกข้อมูลผู้เช่าชาวต่างชาติผ่านคอมพิวเตอร์ โดยมีหนังสือเดินทางวางอยู่บนโต๊ะ", width: 1280, height: 800 },
    sections: [
      { h: "ใครมีหน้าที่แจ้ง ตม.30 ในเชียงใหม่", p: [
        "หน้าที่ตามมาตรา 38 ของพระราชบัญญัติคนเข้าเมืองเป็นของเจ้าบ้าน ผู้ครอบครอง หรือผู้จัดการโรงแรมที่ให้คนต่างด้าวพักอาศัย ไม่ใช่หน้าที่ของคนต่างด้าวเอง ถ้าคุณเป็นชาวต่างชาติที่เช่าคอนโดหรือบ้านในเชียงใหม่ ให้ถามเจ้าของห้องหรือนิติบุคคลว่าแจ้งแล้วหรือยัง และขอสำเนาใบรับแจ้งเก็บไว้ เพราะเจ้าหน้าที่มักขอดูเมื่อยื่นต่อวีซ่าหรือรายงานตัว",
        "ถ้าคุณเป็นเจ้าของที่พักเอง เช่นซื้อคอนโดในชื่อคุณ คุณจะอยู่ในฐานะผู้ครอบครองและต้องแจ้งเอง",
      ]},
      { h: "แจ้งภายในเมื่อไหร่ และยื่นที่ไหน", p: [
        "กฎหมายกำหนดให้แจ้งภายใน 24 ชั่วโมงนับแต่คนต่างด้าวเข้าพัก การกลับเข้าพักที่เดิมไม่ควรถูกเหมารวมว่าต้องแจ้งใหม่ทุกครั้ง ให้ตรวจเงื่อนไขตามระเบียบสำนักงานตำรวจแห่งชาติ พ.ศ. 2563 โดยเฉพาะระยะเวลาที่แจ้งไว้และการอนุญาตให้อยู่ หากย้ายที่พักหรือข้อมูลไม่ตรงกับที่เคยแจ้ง ให้ตรวจหน้าที่แจ้งครั้งใหม่กับสำนักงานตรวจคนเข้าเมืองเชียงใหม่",
        "ช่องทางที่สะดวกที่สุดคือระบบแจ้งออนไลน์ของสำนักงานตรวจคนเข้าเมือง ต้องลงทะเบียนบัญชีเจ้าบ้านก่อน โดยใช้สำเนาทะเบียนบ้าน บัตรประชาชน หรือสัญญาเช่า แล้วรอให้อนุมัติบัญชี ถ้าไม่สะดวกออนไลน์ ก็ยื่นด้วยตนเองที่สำนักงานตรวจคนเข้าเมืองที่มีเขตอำนาจได้",
      ]},
    ],
    steps: [
      "ขอสำเนาหนังสือเดินทางหน้าข้อมูลและหน้าตราเข้าเมืองล่าสุดของผู้เช่า",
      "เตรียมหลักฐานเจ้าบ้านหรือผู้ครอบครอง เช่นทะเบียนบ้าน โฉนดหรือหนังสือกรรมสิทธิ์ห้องชุด หรือสัญญาเช่า",
      "แจ้งผ่านระบบออนไลน์หรือที่สำนักงานภายใน 24 ชั่วโมง",
      "พิมพ์หรือบันทึกใบรับแจ้ง แล้วส่งสำเนาให้ผู้เช่าเก็บไว้ใช้ตอนต่อวีซ่าหรือรายงานตัว",
    ],
    cautions: [
      "การแจ้งช้าหรือไม่แจ้งมีโทษปรับเจ้าบ้านตามกฎหมาย อัตราโทษให้ตรวจจากตัวบทฉบับปัจจุบัน",
      "การแจ้ง ตม.30 ไม่ใช่การรายงานตัว 90 วัน (ตม.47) สองเรื่องนี้ต้องทำแยกกัน",
    ],
    sources: [IMMIGRATION_ACT, TM30_PORTAL, IMMIGRATION, { label: "ระเบียบสำนักงานตำรวจแห่งชาติ — การแจ้งที่พักและเงื่อนไขไม่ต้องแจ้งซ้ำ ข้อ 2.2", url: "https://division2.immigration.go.th/ewtmgnbiz/ewt/IMM2/download/article/article_20240214101357.pdf" }],
    reviewedTh: REVIEWED,
  },
  "/immigration/q/tm30-reporting-deadline": {
    image: { src: tm30Img, alt: "เจ้าของที่พักแจ้งข้อมูลผู้เข้าพักชาวต่างชาติ โดยมีหนังสือเดินทางและกุญแจห้องวางบนโต๊ะ", width: 1280, height: 800 },
    sections: [
      { h: "กำหนดเวลาหลักที่ต้องจำ", p: [
        "ตม.30 คือการแจ้งที่พักของคนต่างด้าว กฎหมายให้เจ้าบ้าน ผู้ครอบครอง หรือผู้จัดการโรงแรมแจ้งภายใน 24 ชั่วโมงหลังคนต่างด้าวเข้าพัก",
        "เรื่องที่คนมักสับสนคือการรายงานตัวทุก 90 วัน (ตม.47) ซึ่งเป็นหน้าที่ของคนต่างด้าวที่อยู่ในไทยต่อเนื่องเกิน 90 วัน สามารถรายงานล่วงหน้าได้ไม่เกิน 15 วันก่อนครบกำหนด หรือหลังครบกำหนดไม่เกิน 7 วัน",
      ]},
      { h: "วันสำคัญอื่นที่ควรใส่ปฏิทินไว้", p: [
        "วันสิ้นสุดการอนุญาตให้อยู่ (ดูจากตราประทับล่าสุดในหนังสือเดินทาง) วันหมดอายุหนังสือเดินทาง วันหมดอายุใบอนุญาตทำงาน และวันสิ้นสุดสัญญาเช่า ถ้าย้ายที่พัก เจ้าบ้านที่พักใหม่ต้องแจ้ง ตม.30 ใหม่",
        "การยื่นขออยู่ต่อควรเผื่อเวลาไว้ล่วงหน้า เพราะเจ้าหน้าที่อาจขอเอกสารเพิ่ม เช่นใบรับแจ้ง ตม.30 ฉบับล่าสุด",
      ]},
    ],
    cautions: [
      "อย่าใช้ใบรับแจ้งเก่าจากที่พักเดิมหลังย้ายบ้าน",
      "โทษปรับกรณีแจ้งช้าเป็นไปตามตัวบทและดุลพินิจเจ้าหน้าที่ ให้ตรวจข้อมูลปัจจุบันจากสำนักงานตรวจคนเข้าเมือง",
    ],
    sources: [IMMIGRATION_ACT, TM30_PORTAL, IMMIGRATION],
    reviewedTh: REVIEWED,
  },
  "/family/q/city-nakhonratchasima": {
    image: { src: civilImg, alt: "เจ้าหน้าที่ทะเบียนตรวจเอกสารประกอบการจดทะเบียนครอบครัวที่เคาน์เตอร์อำเภอ", width: 960, height: 540 },
    sections: [
      { h: "จดทะเบียนสมรสที่นครราชสีมา", p: [
        "การจดทะเบียนสมรสยื่นได้ที่ที่ว่าการอำเภอหรือสำนักงานเขตแห่งใดก็ได้ทั่วประเทศ ไม่จำเป็นต้องเป็นอำเภอตามทะเบียนบ้าน ในโคราชจึงยื่นที่อำเภอเมืองนครราชสีมาหรืออำเภออื่นที่สะดวกได้ ทั้งสองฝ่ายต้องมาแสดงตนและให้ความยินยอมต่อหน้านายทะเบียน และโดยหลักบุคคลทั้งสองฝ่ายต้องมีอายุครบ 18 ปีบริบูรณ์ตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 1448 ที่แก้ไขแล้ว หากมีเหตุอันสมควร ศาลอาจอนุญาตให้สมรสก่อนนั้นได้ และผู้ที่ยังไม่บรรลุนิติภาวะต้องตรวจเงื่อนไขความยินยอมที่เกี่ยวข้องด้วย",
        "ถ้าคู่สมรสเป็นชาวต่างชาติ ต้องมีหนังสือรับรองสถานภาพโสดหรือหนังสือยืนยันความสามารถในการสมรสจากสถานทูต แปลเป็นภาษาไทย แล้วนำไปรับรองที่กองสัญชาติและนิติกรณ์ กรมการกงสุล ก่อนยื่นที่อำเภอ บางอำเภออาจขอพยาน 2 คน หรือล่ามถ้าคู่สมรสไม่เข้าใจภาษาไทย",
      ]},
      { h: "จดทะเบียนหย่าที่นครราชสีมา", p: [
        "การหย่าโดยความยินยอมต้องทำเป็นหนังสือ มีพยานลงชื่ออย่างน้อย 2 คน และจดทะเบียนหย่าที่อำเภอหรือเขต (มาตรา 1514–1515) โดยทั่วไปทั้งสองฝ่ายต้องมาพร้อมกัน ควรตกลงเรื่องสินสมรส อำนาจปกครองบุตร และค่าอุปการะเลี้ยงดูให้ชัดก่อน เพื่อบันทึกไว้ในทะเบียน",
        "ถ้าตกลงกันไม่ได้ หรืออีกฝ่ายไม่ยอมมาอำเภอ ต้องฟ้องหย่าต่อศาลที่มีเขตอำนาจ เช่นศาลเยาวชนและครอบครัวจังหวัดนครราชสีมา",
      ]},
    ],
    steps: [
      "เตรียมบัตรประชาชน ทะเบียนบ้าน หรือหนังสือเดินทางของทั้งสองฝ่าย",
      "คู่สมรสต่างชาติ: ขอหนังสือรับรองจากสถานทูต แปลเป็นภาษาไทย แล้วรับรองที่กรมการกงสุล",
      "โทรถามอำเภอที่จะยื่นว่าต้องนัดหมาย ต้องมีพยาน หรือต้องมีล่ามหรือไม่",
      "ยื่นพร้อมกันทั้งสองฝ่าย แล้วตรวจชื่อและวันที่ในทะเบียนก่อนลงนาม",
    ],
    cautions: [
      "เอกสารต่างประเทศที่ยังไม่ผ่านการรับรองของกรมการกงสุลมักถูกปฏิเสธ",
      "ข้อตกลงหย่าที่ลงทะเบียนแล้วแก้ไขภายหลังได้ยาก ควรให้ทนายตรวจก่อนลงนาม",
    ],
    sources: [
      { label: "ประมวลกฎหมายแพ่งและพาณิชย์ บรรพ 5 ครอบครัว (สำนักงานคณะกรรมการกฤษฎีกา)", url: "https://www.krisdika.go.th/" },
      { label: "สำนักงานเลขาธิการสภาผู้แทนราษฎร — กฎหมายสมรสเท่าเทียมและอายุขั้นต่ำ 18 ปี", url: "https://library.parliament.go.th/th/radioscript/rr2568-mar6" },
      { label: "กรมการปกครอง — งานทะเบียนครอบครัว", url: "https://www.dopa.go.th/" },
      { label: "กรมการกงสุล — การรับรองเอกสาร", url: "https://www.mfa.go.th/en/publicservice/5d5bcc2615e39c306000a328?cate=5d5bcb4e15e39c30600068d3" },
    ],
    reviewedTh: REVIEWED,
  },
  "/litigation/q/litigation-w-bankruptcy-recovery-poa-steps": {
    image: { src: poaImg, alt: "ผู้มอบอำนาจลงนามหนังสือมอบอำนาจต่อหน้าเจ้าหน้าที่รับรองเอกสาร", width: 960, height: 540 },
    sections: [
      { h: "ทำไมคดีล้มละลายมักต้องใช้หนังสือมอบอำนาจ", p: [
        "เจ้าหนี้ที่ต้องการรับชำระหนี้จากลูกหนี้ซึ่งศาลสั่งพิทักษ์ทรัพย์เด็ดขาดแล้ว ต้องยื่นคำขอรับชำระหนี้ต่อเจ้าพนักงานพิทักษ์ทรัพย์ กรมบังคับคดี ภายในสองเดือนนับแต่วันโฆษณาคำสั่งพิทักษ์ทรัพย์เด็ดขาด ตามมาตรา 91 พระราชบัญญัติล้มละลาย พ.ศ. 2483 เจ้าหนี้ที่อยู่ต่างประเทศอาจขอขยายเวลาได้ตามที่กฎหมายกำหนด",
        "เจ้าหนี้ที่เป็นบริษัทหรืออยู่ต่างประเทศมักไม่สามารถไปยื่นเองได้ จึงต้องมอบอำนาจให้ทนายหรือผู้รับมอบอำนาจในไทยยื่นแทน และให้ไปประชุมเจ้าหนี้แทน",
      ]},
      { h: "หนังสือมอบอำนาจต้องมีอะไร", p: [
        "ระบุชื่อลูกหนี้ เลขคดีล้มละลาย และขอบเขตอำนาจให้ชัด เช่นยื่นคำขอรับชำระหนี้ เข้าประชุมเจ้าหนี้ ลงมติ และรับเงินส่วนเฉลี่ย ถ้าผู้มอบอำนาจเป็นนิติบุคคล ต้องแนบหลักฐานว่าผู้ลงนามมีอำนาจกระทำการแทนบริษัท",
        "หนังสือที่ลงนามในต่างประเทศโดยทั่วไปต้องรับรองโดย Notary Public ของประเทศนั้น แล้วรับรองต่อที่สถานทูตหรือกงสุลไทย ส่วน Apostille ต้องตรวจทั้งวันมีผลกับไทย ความสัมพันธ์ระหว่างประเทศที่ออกเอกสารกับไทย และการยอมรับของหน่วยงานผู้รับก่อนใช้ แล้วจัดคำแปลภาษาไทยตามที่กำหนด",
      ]},
    ],
    steps: [
      "ตรวจประกาศคำสั่งพิทักษ์ทรัพย์เด็ดขาด และนับวันครบกำหนดยื่นคำขอรับชำระหนี้",
      "ร่างหนังสือมอบอำนาจที่ระบุเลขคดีและขอบเขตอำนาจ",
      "ลงนามต่อหน้า Notary แล้วรับรองต่อตามประเทศที่ลงนาม",
      "แปลเป็นภาษาไทย แล้วยื่นพร้อมหลักฐานหนี้ต่อเจ้าพนักงานพิทักษ์ทรัพย์",
    ],
    cautions: [
      "ยื่นเกินกำหนดอาจหมดสิทธิรับส่วนแบ่งจากกองทรัพย์สิน เผื่อเวลาสำหรับการรับรองเอกสารในต่างประเทศด้วย",
      "หน้านี้เป็นข้อมูลทั่วไป ไม่ใช่การประเมินว่าจะได้รับชำระหนี้เท่าใด",
    ],
    sources: [
      { label: "พระราชบัญญัติล้มละลาย พ.ศ. 2483 (สำนักงานคณะกรรมการกฤษฎีกา)", url: "https://www.krisdika.go.th/" },
      { label: "กรมบังคับคดี — งานล้มละลาย", url: "https://www.led.go.th/" },
      { label: "กรมการกงสุล — การรับรองเอกสาร", url: "https://www.mfa.go.th/en/publicservice/5d5bcc2615e39c306000a328?cate=5d5bcb4e15e39c30600068d3" },
    ],
    reviewedTh: REVIEWED,
  },
};
